export default "__VITE_ASSET__ymX52OwS__"